interface BootstrapModal {
    show(): void;
    hide(): void;
}

declare const bootstrap: {
    Modal: {
        getOrCreateInstance(element: Element): BootstrapModal;
    };
};

$(document).ready(function () {
    new TaskList();
});

export class TaskList {
    private initialised: boolean = false;
    private _modal: BootstrapModal;
    private _modalCreate: BootstrapModal;

    private _taskListElement: JQuery<HTMLElement>;
    private _taskEditorElement: JQuery<HTMLElement>;
    private _taskListExpanderElement: JQuery<HTMLElement>;
    private _taskCreatorElement: JQuery<HTMLElement>;

    constructor() {
        this.init();
    }

    private init = () => {
        if (this.initialised) {
            return;
        }

        this.loadTaskList(false);
        this.initialised = true;
    }

    private loadTaskList = (showExpanded): void => {
        let self = this;

        // grab the DOM target element for the task listing
        // and read its data attributes
        self._taskListElement = $("#TasksTarget");

        if (self._taskListElement[0]) {
            let recordType = self._taskListElement[0].dataset.recordType;
            let recordUID = self._taskListElement[0].dataset.recordUid;

            // load the listing partial view
            self._taskListElement.load(`/TaskPartial/RefreshTasksPartial/${recordType}/${recordUID}`, function () {

                // identify DOM targets within the listing partial view
                self.identifyDomElements();
            
                if (showExpanded === true) {
                    // expand the collapsed task listing
                    self._taskListExpanderElement.addClass("show");
                }

                // all Edit buttons need to get a click handler to open modal
                $(".edit-task").on("click", function () {  

                    // apparently $(this) is the identifier of the button that got clicked on, 
                    // which is given a 'taskid' data attribute in the partial view
                    self.loadTaskEditor($(this)[0].dataset.taskid);
                });

                // the Add button opens the Create modal
                $("#createTaskLink").on("click", function () {
                    self.loadTaskCreator($(this)[0].dataset.entitycode, $(this)[0].dataset.recordid);
                });
            });
        }
    }

    private identifyDomElements = (): void => {
        let self = this;

        self._modal                   = bootstrap.Modal.getOrCreateInstance(document.getElementById('TaskListModal'));
        self._taskEditorElement = $('#TaskEditor');
        self._taskListExpanderElement = $('#TaskListExpandableContainer');        
        self._modalCreate             = bootstrap.Modal.getOrCreateInstance(document.getElementById('TaskCreateModal'));
        self._taskCreatorElement      = $('#TaskCreator');
    }

    private loadTaskEditor = (taskId): void => {
        let self = this;

        // get the editing partial view and load it into the placeholder in the modal
        self._taskEditorElement.load("/TaskPartial/EditorPartial/" + taskId, function () {

            self._modal.show();

            // hook up the buttons inside the editing modal
            self.attachHandlersToEditorButtons();
        });
    }

    // Handler for click on Update button
    private onEditSubmit = (entityCode, taskid): void => {
        let self = this;

        // post back form data to UpdatePartial action on controller
        $.post(`/TaskPartial/UpdatePartial/${entityCode}/${taskid}`, $("#TaskEditForm").serialize())
            .done(function (response) {

                // controller has saved without error...
                if (response === "UpdateSuccess") {

                    self.dismissModal(self._modal);

                    // refresh the task listing on edit success
                    self.loadTaskList(true);
                }
                else {
                    // if a concurrency error occurs, the controller returns the partial view plus an error message 
                    // and modified TimeStamp as 'response'... re-load this as the editor partial view
                    self._taskEditorElement.html(response);  

                    //...and reattach its buttons
                    self.attachHandlersToEditorButtons();
                }
            })
            .fail(function () {
                // other unexpected error in controller update
                window.location.href = "/Oops/Error";
            });
    }


    // Handler for click on Delete button
    private onEditDelete = (recordid, taskid): void => {
        let self = this;

        // post back form data to UpdatePartial action on controller
        $.get(`/TaskPartial/Delete/${recordid}/${taskid}`)
            .done(function() {

                // refresh listing and close modal
                self.loadTaskList(true);
                self.dismissModal(self._modal);
            })
            .fail(function () {
                // unexpected error in controller delete
                window.location.href = "/Oops/Error";
            });
    }

    private attachHandlersToEditorButtons = (): void => {
        let self = this;

        // attach handler to the (now present) Submit button
        $("#TaskEditSubmit").on("click", function () {
            self.onEditSubmit($(this)[0].dataset.entitycode, $(this)[0].dataset.taskid);
        });

        // attach handler to the Cancel button
        $("#TaskEditCancel").on("click", function () {
            self.loadTaskList(true);
            self.dismissModal(self._modal);
        });

        // attach handler to the Delete button
        $("#TaskEditDelete").on("click", function () {
            self.onEditDelete($(this)[0].dataset.recordid, $(this)[0].dataset.taskid);
        });
    }
    
    private loadTaskCreator = (entitycode, recordid): void => {
        let self = this;

        // get the create partial view and load it into the placeholder in the modal
        self._taskCreatorElement.load(`/TaskPartial/CreatePartial/${entitycode}/${recordid}`, function () {

            self._modalCreate.show();

            // hook up the buttons inside the editing modal
            self.attachHandlersToCreateButtons();
        });
    }

    private attachHandlersToCreateButtons = (): void => {
        let self = this;

        // attach handler to the (now present) Create button
        $("#TaskCreateSubmit").on("click", function () {
            self.onCreateSubmit($(this)[0].dataset.entitycode, $(this)[0].dataset.recordid);
        });

        // attach handler to the Cancel button
        $("#TaskCreateCancel").on("click", function () {

            // reload the main tasks listing and preserve its expanded (or not) state
            if (self._taskListExpanderElement.hasClass("show")) {
                self.loadTaskList(true);
            }
            else {
                self.loadTaskList(false);
            }

            self.dismissModal(self._modalCreate);
        });
    }

    // Handler for click on Update button
    private onCreateSubmit = (entityCode, recordid): void => {
        let self = this;

        // post back form data to CreatePartial action on controller
        $.post(`/TaskPartial/CreatePartial/${entityCode}/${recordid}`, $("#TaskCreateForm").serialize())
            .done(function () {

                self.dismissModal(self._modalCreate);

                // refresh the task listing
                self.loadTaskList(true);
            })
            .fail(function () {
                // error in controller save
                window.location.href = "/Oops/Error";
            });
    }

    private dismissModal = (modalElement: BootstrapModal): void => {
        modalElement.hide();

        /// These can fix the issue of grey backdrop remaining on modal close (crudely).
        /// But instead solved issue by removing modal placeholders from the TaskListing DOM element
        // $(document.body).removeClass("modal-open");
        // $(".modal-backdrop").remove();
    }
}